import React from 'react';
import { Button, Card } from '@mantine/core';
import { IconCirclePlus } from '@tabler/icons-react';
import { useDisclosure } from '@mantine/hooks';

import { DashboardHeader } from '../../components/common';
import StandInFormModal from '../../components/stand-in-management/StandInFormModal';
import StandInCalendar from '../../components/stand-in-management/StandInCalendar';

function StandInCalendarPage() {
    const [addStandInModalOpened, standInModalHandlers] = useDisclosure(false);

    return (
        <div className="relative">
            <DashboardHeader
                title="Stand-In Calendar"
                friendlyLabels={[
                    {
                        originalLabel: 'stand-in',
                        friendlyLabel: 'Stand-In Management',
                    },
                ]}
                hasBreadcrumb={false}
                hasDate
                isLoading={false}
                rightComponent={
                    <Button
                        fullWidth={false}
                        rightSection={<IconCirclePlus size={20} />}
                        onClick={standInModalHandlers.open}
                        size="md"
                    >
                        Add Stand In
                    </Button>
                }
            />
            <div className="relative w-full h-full px-11 py-6">
                <Card
                    className="relative w-full h-[calc(100vh-208px)] overflow-hidden rounded-xl"
                    shadow="lg"
                >
                    <StandInCalendar />
                </Card>
            </div>
            <StandInFormModal
                onClose={standInModalHandlers.close}
                opened={addStandInModalOpened}
            />
        </div>
    );
}
export default StandInCalendarPage;
